export default () => item => {
    switch (item.type) {
        case 'SerializedDate':
            return item.name + '.Milliseconds';
        default:
            return item.name;
    }
}